import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

interface MarkdownRendererProps {
    content: string;
    className?: string;
}

export const MarkdownRenderer = ({ content, className }: MarkdownRendererProps) => {
    return (
        <div className={cn("prose prose-sm dark:prose-invert max-w-none break-words", className)}>
            <ReactMarkdown
                components={{
                    code({ node, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || '');
                        // simple inline code vs block code
                        const isInline = !match && !String(children).includes('\n');

                        if (isInline) {
                            return (
                                <code className="bg-muted px-1.5 py-0.5 rounded-md font-mono text-sm" {...props}>
                                    {children}
                                </code>
                            );
                        }

                        return (
                            <div className="relative my-4 rounded-lg bg-black/5 dark:bg-black/40 p-4">
                                <code className={cn("block font-mono text-sm overflow-x-auto", className)} {...props}>
                                    {children}
                                </code>
                            </div>
                        );
                    },
                    ul({ children }) {
                        return <ul className="list-disc pl-4 my-2 space-y-1">{children}</ul>;
                    },
                    ol({ children }) {
                        return <ol className="list-decimal pl-4 my-2 space-y-1">{children}</ol>;
                    },
                    li({ children }) {
                        return <li>{children}</li>;
                    },
                    p({ children }) {
                        return <p className="leading-relaxed mb-2 last:mb-0">{children}</p>;
                    },
                    a({ href, children }) {
                        return (
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary hover:underline font-medium"
                            >
                                {children}
                            </a>
                        );
                    }
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};
